var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.478,17.208l4.152-4.1L23.478,9l-.978.964,3.174,3.14L22.5,16.244Z",
    transform: "translate(-7.11 -2.844)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.788,3.368a3.42,3.42,0,1,1-3.42,3.42,3.42,3.42,0,0,1,3.42-3.42M9.788,2a4.788,4.788,0,1,0,4.788,4.788A4.788,4.788,0,0,0,9.788,2Z",
    transform: "translate(-1.58 -0.632)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.68,26.208H14.312v-3.42a3.42,3.42,0,0,0-3.42-3.42h-4.1a3.42,3.42,0,0,0-3.42,3.42v3.42H2v-3.42A4.788,4.788,0,0,1,6.788,18h4.1a4.788,4.788,0,0,1,4.788,4.788Z",
    transform: "translate(-0.632 -5.688)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserArrowRight);
export default __webpack_public_path__ + "static/media/user-arrow-right.2f10c70deda16293604503e26976b252.svg";
export { ForwardRef as ReactComponent };